var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full my-5",attrs:{"contenteditable":_vm.allowEditing,"value":_vm.value},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"input":function($event){return _vm.$emit('input', $event.target.innerHTML)}}})
}]

export { render, staticRenderFns }